import { useState } from "react";
import { Send } from "lucide-react";
import { apiClient, formatApiError } from "../lib/api";
import { toast } from "sonner";

export default function SendToPartner({ quote, partners, onSent }) {
  const [open, setOpen] = useState(false);
  const [pid, setPid] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [note, setNote] = useState("");
  const [sending, setSending] = useState(false);

  const choose = (id) => {
    setPid(id);
    const p = partners.find((x) => x.id === id);
    if (p) { setName(p.company_name || `${p.first_name} ${p.last_name}`); setEmail(p.email); }
  };
  const send = async () => {
    setSending(true);
    try {
      const r = await apiClient.post(`/admin/devis/${quote.id}/send`, { to_email: email, partner_name: name, note });
      toast.success(`Lead envoyé à ${name}`);
      onSent(r.data.sent, name);
      setOpen(false);
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail) || e.message);
    } finally {
      setSending(false);
    }
  };

  if (!open)
    return (
      <button onClick={() => setOpen(true)} className="btn-sun w-full py-2 text-xs" data-testid={`send-open-${quote.id}`}>
        <Send size={13} /> Envoyer à une conciergerie
      </button>
    );
  const cls = "w-full text-sm rounded-full px-4 py-2 border border-input bg-background";
  return (
    <div className="space-y-2 rounded-2xl border border-border p-3 bg-secondary/50" data-testid={`send-panel-${quote.id}`}>
      {partners.length > 0 && (
        <select value={pid} onChange={(e) => choose(e.target.value)} className={cls} data-testid={`send-partner-select-${quote.id}`}>
          <option value="">Choisir une conciergerie partenaire…</option>
          {partners.map((p) => <option key={p.id} value={p.id}>{p.company_name || `${p.first_name} ${p.last_name}`} · {p.zone || p.city}</option>)}
        </select>
      )}
      <input value={name} onChange={(e) => setName(e.target.value)} placeholder="Nom de la conciergerie" className={cls} data-testid={`send-name-${quote.id}`} />
      <input value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email de la conciergerie" className={cls} data-testid={`send-email-${quote.id}`} />
      <textarea value={note} onChange={(e) => setNote(e.target.value)} rows={2} placeholder="Note pour la conciergerie (facultatif)" className="w-full text-sm rounded-2xl px-4 py-2 border border-input bg-background" data-testid={`send-note-${quote.id}`} />
      <div className="flex gap-2">
        <button onClick={send} disabled={!name || !/\S+@\S+\.\S+/.test(email) || sending} className="btn-accent flex-1 py-2 text-xs disabled:opacity-50" data-testid={`send-submit-${quote.id}`}>
          {sending ? "Envoi…" : "Envoyer toutes les infos"}
        </button>
        <button onClick={() => setOpen(false)} className="btn-ghost py-2 px-3 text-xs">Annuler</button>
      </div>
    </div>
  );
}
